import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";

export async function exportGLTF(scene) {
  scene.traverse((node) => {
    if (node.name.startsWith("exclude_gltf_")) {
      node.visible = false;
    }
  });

  try {
    const glb = await new Promise((resolve, reject) => {
      const exporter = new GLTFExporter();
      exporter.parse(scene, resolve, reject, {
        binary: true,
        includeCustomExtensions: true,
      });
    });
    return glb;
  } finally {
    scene.traverse((node) => {
      if (node.name.startsWith("exclude_gltf_")) {
        node.visible = true;
      }
    });
  }
}
